import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import { FC } from 'react'
import CalendarArrowUpIcon from '../../../../assets/icons/CalendarArrowUp.svg?react'
import { NumberWithCorrectPostfix } from '../../../../components/NumberWithCorrectPostfix'
import { regularRequestsChipPostfix } from '../../../../constants/regularRequests.constants'

type Props = {
    requestsCount: number
}

export const RegularRequestsChip: FC<Props> = ({ requestsCount }) => {
    const { breakpoints } = useTheme()

    const isMobile = useMediaQuery(breakpoints.down('md'))

    return (
        <Box
            sx={{
                height: 'fit-content',
                width: 'fit-content',
                minWidth: '128px',
                backgroundColor: 'transparent',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: '6px',
                p: '2px 8px 2px 0',
            }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                }}>
                <CalendarArrowUpIcon width={16} height={16} color="#8F93A3" />
            </Box>
            <Typography variant="caption2" color="#8F93A3">
                {isMobile ? (
                    requestsCount
                ) : (
                    <NumberWithCorrectPostfix
                        value={requestsCount}
                        postfix={regularRequestsChipPostfix}
                    />
                )}
            </Typography>
        </Box>
    )
}
